/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Passwordplaceholder1Inputs */

const en_passwordplaceholder1 = /** @type {(inputs: Passwordplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`••••••••`)
};

const de_passwordplaceholder1 = /** @type {(inputs: Passwordplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`••••••••`)
};

/**
* | output |
* | --- |
* | "••••••••" |
*
* @param {Passwordplaceholder1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const passwordplaceholder1 = /** @type {((inputs?: Passwordplaceholder1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Passwordplaceholder1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_passwordplaceholder1(inputs)
	return de_passwordplaceholder1(inputs)
});
export { passwordplaceholder1 as "passwordPlaceholder" }